export default class AnimationHelper {

  static triggerAnimation (el, activeClass, type, delay = 10, visibleDisplay = 'block') {
    if (type === 'in') {
      el.style.display = visibleDisplay

      setTimeout(() => {
        el.classList.add(activeClass)
      }, delay)
    }

    else if (type === 'out') {
      el.classList.remove(activeClass)

      setTimeout(() => {
        el.style.display = 'none'
      }, delay)
    }

  }

}